import { Enum } from '../commons/common';

export interface Order {
    id: string;
    trackingCode: string;
    pair: {
        base: string;
        quote: string;
    };
    sourceQuantity: number;
    destinationQuantity: number;
    type: Enum;
    createdBy: string;
    side: Enum;
    state: Enum;
    createdOn: string;
    commission: number;
    marketType: number;
    source: Enum;
    user: {
        firstName: string;
        lastName: string;
        userName: string;
    };
    phoneNumber: string;
    baseBalanceAfterOrder: number;
    quoteBalanceAfterOrder: number;
    onPrice: number;
    inDollarPrice: number;
    inDollarAmount: number;
}

export interface OrderCount {
    pageSize: number;
    pageIndex: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export enum SortDirection {
    ASC = 0,
    DESC = 1,
}

export interface OrderFilterValues {
    startDate?: string;
    endDate?: string;
    sort?: SortDirection;
    market?: string;
    keywords?: string;
    source?: Enum;
    side: Enum;
    marketType?: Enum;
    type?: Enum;
    state?: Enum;
}

export enum OrderAction {
    ConfirmAndPayout = 100,
    Succeed = 7,
    Cancel = 1,
}

export const OrderActionLabel = new Map<number, string>([
    [OrderAction.ConfirmAndPayout, "تایید و تسویه"],
]);
